module.exports = __webpack_public_path__ + "img/3d971fd942333a36b073d84866251432.png";